<script>
  import NewsletterPromo from './NewsletterPromo.svelte'
  import Credits from '../components/Credits.svelte'
</script>

<footer>
  <Credits />
</footer>

<style>
  footer {
    z-index: 1000;
    width: 100%;
    text-align: center;
    /* padding: 30px; */
    padding-top: 30px;
    padding-bottom: 30px;
    color: #fff;
  }
</style>
